import { Component, inject } from '@angular/core';
import { Option } from '@cumlaude/shared-utils';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { IconComponent } from '@cumlaude/shared-components-icons';

export interface DuoSelectDropdownData<A, B> {
	optiesA: Option<A>[];
	optiesB: Option<B>[];
	selectedOptieA: Option<A>;
	selectedOptieB: Option<B>;
	optieAHeader: string;
	optieBHeader: string;
	label?: string;
}

export interface DuoSelectDropdownResponse<A, B> {
	optieA?: Option<A>;
	optieB?: Option<B>;
}

@Component({
	selector: 'app-duo-select-dropdown-dialog',
	templateUrl: './duo-select-dropdown-dialog.component.html',
	styleUrls: ['./duo-select-dropdown-dialog.component.scss'],
	imports: [IconComponent],
})
export class DuoSelectDropdownDialogComponent<A, B> {
	dialogRef = inject<DialogRef<DuoSelectDropdownResponse<A, B>>>(DialogRef);
	data = inject<DuoSelectDropdownData<A, B>>(DIALOG_DATA);

	changeA(optieA: Option<A>) {
		this.close(optieA, undefined);
	}

	changeB(optieB: Option<B>) {
		this.close(undefined, optieB);
	}

	close(optieA: Option<A> | undefined, optieB: Option<B> | undefined) {
		this.dialogRef.close({ optieA, optieB });
	}

	isSelectedA(option: Option<A>) {
		return this.data.selectedOptieA.value === option.value;
	}

	isSelectedB(option: Option<B>) {
		return this.data.selectedOptieB.value === option.value;
	}
}
